var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.396,
    height: 30.661,
    viewBox: "0 0 34.396 30.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.5;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0.001 -27.798)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.001 27.798)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M34.029,39.908,17.725,27.97a.894.894,0,0,0-1.056,0L.365,39.908A.894.894,0,0,0,1.421,41.35L17.2,29.8,32.974,41.35a.894.894,0,0,0,1.056-1.442Z",
    transform: "translate(0.001 -27.798)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.792 41.552)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M82.369,232.543a.894.894,0,0,0-.894.894v14.225H74.326V239.9a4.469,4.469,0,1,0-8.938,0v7.765H58.239V233.437a.894.894,0,1,0-1.787,0v15.119a.894.894,0,0,0,.894.894h8.937a.893.893,0,0,0,.89-.824.676.676,0,0,0,0-.07V239.9a2.681,2.681,0,0,1,5.363,0v8.659a.656.656,0,0,0,0,.069.893.893,0,0,0,.89.825h8.937a.894.894,0,0,0,.894-.894V233.437A.894.894,0,0,0,82.369,232.543Z",
    transform: "translate(-56.452 -232.543)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.e60afbde941c2b9b64e4984399fa506c.svg";
export { ForwardRef as ReactComponent };